import { Colors, FInter, FlexBox, RectangularButtonFilled, RectangularButtonHollow } from "@brg/ui";
import { LayoutConst } from "core";
import styled from "styled-components";


export const ModalButtonHollow = styled(RectangularButtonHollow)`
    padding: 12px 15px;
    height: 46px !important;
    margin-right: 0;
    line-height: 22px !important;
    font-size: 17px !important;
    width: 100%;

            @media (max-width: ${LayoutConst.screen.mac13}px),
    (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
    }
`

export const ModalButtonFilled = styled(RectangularButtonFilled)`
    padding: 12px 15px;
    height: 46px !important;
    margin-height: 0;
    line-height: 22px !important;
    font-size: 17px !important;
        width: 100%;

        @media (max-width: ${LayoutConst.screen.mac13}px),
    (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
    }
`


export const Wrapper = styled(FlexBox)`
    width: 564px;
    padding: 32px 40px;
    border-radius: 8px;
    background: ${({theme}) => theme.mainBg};
    margin-bottom: 0%;
    max-width: 560px;
    align-items: start;

    svg {
        cursor: pointer;

        path {
            transition: fill 0.2s;
        }

        &:hover {
            path: {
                fill: #151514;
                transition: fill 0.2s;
            }
        }
    }

    
    @media (max-width: ${LayoutConst.screen.s - 1}px) {
      width: calc(100vw - 20px);
      padding: 16px;

      button {
        width: 100%;
        max-width: 100%;
        min-width: 100%;
      }
    }
`;

export const Title = styled(FInter.Text)`
    font-family: Inter;
    font-size: 28px;
    font-style: normal;
    font-weight: 600;
    letter-spacing: -0.02em;
    line-height: 34px;
    margin-bottom: 0px;

    @media (max-width: ${LayoutConst.screen.mac13}px),
    (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 23px;
        line-height: 27px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        font-size: 17px;
        line-height: 22px;
    }
`

export const Subtitle = styled(FInter.Text)`
    font-family: Inter;
    font-size: 17px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: -0.02em;

        @media (max-width: ${LayoutConst.screen.mac13}px),
    (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        font-size: 11px;
        line-height: 13px;
    }
`;

export const SmallText = styled.div`
    font-size: 17px;
    line-height: 22px;
    font-weight: 400;
    color: ${Colors.galBlack47};
`;

export const DropdownWrapper = styled(FlexBox)`
    width: 100%;

    .brg-input__control {
        width: 100%;
        border-color: ${(p) => p.theme.dropdown.borderColor};
        background-color: ${({ theme }) => theme.projectEdit.imgContainerBg};

         .brg-input__placeholder {
                color: #909090;
            }
            &:focus {
                border-color: #30363A;
                .brg-input__placeholder {
                    color: #909090;
                }
            }
            &:active {
                border-color: #30363A;
                .brg-input__placeholder {
                    color: #909090;
                }
            }
            &:hover {
                border-color: #30363A;
                .brg-input__placeholder {
                    color: #909090;
                }
            }
    }

      .brg-input__menu {
        background-color: ${({theme}) => theme.competition.input.bg} !important;
    
        .brg-input__option {
          cursor: pointer;
          color: ${({theme}) => theme.competition.input.inputText} !important;
          svg {
            path {
              fill: ${({theme}) => theme.competition.input.inputText} !important;
            }
          }
        }
        .brg-input__option--is-focused {
          background-color: ${({theme}) => theme.competition.input.bgActive} !important;
        }
        .brg-input__option--is-focused:hover {
          background-color: ${({theme}) => theme.competition.input.bgActive} !important;
        }
      }
    
     .brg-input__menu-list {
        &::-webkit-scrollbar {
          height: 1px;
          width: 2px;
        }
        &::-webkit-scrollbar-track {
          border-radius: 10px;
          background: ${({theme}) => theme.competition.input.bgActive} !important;
        }
        &::-webkit-scrollbar-thumb {
          background: ${({theme}) => theme.competition.input.inputText} !important;
        }
      }
    
      .brg-input__option {
        height: 48px !important;
        display: flex;
        align-items: center;
        height: min-content !important;
        min-height: 48px !important;
    
        svg {
          fill: ${(p) => p.theme.dropdown.arrow};
        }
      }

      
    .brg-input__indicators {
        align-items: start;
    }

    .brg-input__indicator {
        padding-top: 14px;
        margin-right: 0;
        svg {
          path {
            fill: ${({theme}) => theme.competition.input.inputText} !important;;
          }
        }
    }
    
      .brg-input__option--is-focused {
        background: ${(p) => p.theme.dropdown.bgColorHover} !important;
      }
    
      .brg-input__option--is-selected {
        background: none;
      }
    
      .brg-input__menu-notice {
        font-family: Inter, sans-serif;
        height: 48px !important;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding: 0 16px;
        font-style: normal;
        font-weight: 500;
        font-size: 10px;
        line-height: 13px;
        letter-spacing: 0.06em;
        color: ${(p) => p.theme.dropdown.textColor};
      }
    
      .brg-input__single-value {
        color: ${(p) => p.theme.dropdown.textColor};
      }

    
`;

export const RepostedText = styled.div`
  font-size: 20px;
  line-height: 28px;
  color: ${(p) => p.theme.dropdown.textColor};
  text-align: center;
`

export const RadioContainer = styled(FlexBox)`
  * {
  margin-bottom: 0px;
}
`;

export const FieldTitle = styled.div<any>`
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 133.333% */
    letter-spacing: -0.3px;
    color: ${p => p.theme.not_saved_modal.channelTitle || '#151514'};
    margin-bottom: 12px;
`;
import { Colors, FInter, FlexBox, RectangularButtonFilled, RectangularButtonHollow } from "@brg/ui";
import { LayoutConst } from "core";
import styled from "styled-components";


export const ModalButtonHollow = styled(RectangularButtonHollow)`
    padding: 12px 15px;
    height: 46px !important;
    margin-right: 0;
    line-height: 22px !important;
    font-size: 17px !important;
    width: 100%;

            @media (max-width: ${LayoutConst.screen.mac13}px),
    (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
    }
`

export const ModalButtonFilled = styled(RectangularButtonFilled)`
    padding: 12px 15px;
    height: 46px !important;
    margin-height: 0;
    line-height: 22px !important;
    font-size: 17px !important;
        width: 100%;

        @media (max-width: ${LayoutConst.screen.mac13}px),
    (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
    }
`


export const Wrapper = styled(FlexBox)`
    width: 564px;
    padding: 32px 40px;
    border-radius: 8px;
    background: ${({theme}) => theme.mainBg};
    margin-bottom: 0%;
    max-width: 560px;
    align-items: start;

    svg {
        cursor: pointer;

        path {
            transition: fill 0.2s;
        }

        &:hover {
            path: {
                fill: #151514;
                transition: fill 0.2s;
            }
        }
    }

    
    @media (max-width: ${LayoutConst.screen.s - 1}px) {
      width: calc(100vw - 20px);
      padding: 16px;

      button {
        width: 100%;
        max-width: 100%;
        min-width: 100%;
      }
    }
`;

export const Title = styled(FInter.Text)`
    font-family: Inter;
    font-size: 28px;
    font-style: normal;
    font-weight: 600;
    letter-spacing: -0.02em;
    line-height: 34px;
    margin-bottom: 0px;

    @media (max-width: ${LayoutConst.screen.mac13}px),
    (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 23px;
        line-height: 27px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        font-size: 17px;
        line-height: 22px;
    }
`

export const Subtitle = styled(FInter.Text)`
    font-family: Inter;
    font-size: 17px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: -0.02em;

        @media (max-width: ${LayoutConst.screen.mac13}px),
    (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        font-size: 11px;
        line-height: 13px;
    }
`;

export const SmallText = styled.div`
    font-size: 17px;
    line-height: 22px;
    font-weight: 400;
    color: ${Colors.galBlack47};
`;

export const DropdownWrapper = styled(FlexBox)`
    width: 100%;

    .brg-input__control {
        width: 100%;
        border-color: ${(p) => p.theme.dropdown.borderColor};
        background-color: ${({ theme }) => theme.projectEdit.imgContainerBg};

         .brg-input__placeholder {
                color: #909090;
            }
            &:focus {
                border-color: #30363A;
                .brg-input__placeholder {
                    color: #909090;
                }
            }
            &:active {
                border-color: #30363A;
                .brg-input__placeholder {
                    color: #909090;
                }
            }
            &:hover {
                border-color: #30363A;
                .brg-input__placeholder {
                    color: #909090;
                }
            }
    }

      .brg-input__menu {
        background-color: ${({theme}) => theme.competition.input.bg} !important;
    
        .brg-input__option {
          cursor: pointer;
          color: ${({theme}) => theme.competition.input.inputText} !important;
          svg {
            path {
              fill: ${({theme}) => theme.competition.input.inputText} !important;
            }
          }
        }
        .brg-input__option--is-focused {
          background-color: ${({theme}) => theme.competition.input.bgActive} !important;
        }
        .brg-input__option--is-focused:hover {
          background-color: ${({theme}) => theme.competition.input.bgActive} !important;
        }
      }
    
     .brg-input__menu-list {
        &::-webkit-scrollbar {
          height: 1px;
          width: 2px;
        }
        &::-webkit-scrollbar-track {
          border-radius: 10px;
          background: ${({theme}) => theme.competition.input.bgActive} !important;
        }
        &::-webkit-scrollbar-thumb {
          background: ${({theme}) => theme.competition.input.inputText} !important;
        }
      }
    
      .brg-input__option {
        height: 48px !important;
        display: flex;
        align-items: center;
        height: min-content !important;
        min-height: 48px !important;
    
        svg {
          fill: ${(p) => p.theme.dropdown.arrow};
        }
      }

      
    .brg-input__indicators {
        align-items: start;
    }

    .brg-input__indicator {
        padding-top: 14px;
        margin-right: 0;
        svg {
          path {
            fill: ${({theme}) => theme.competition.input.inputText} !important;;
          }
        }
    }
    
      .brg-input__option--is-focused {
        background: ${(p) => p.theme.dropdown.bgColorHover} !important;
      }
    
      .brg-input__option--is-selected {
        background: none;
      }
    
      .brg-input__menu-notice {
        font-family: Inter, sans-serif;
        height: 48px !important;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding: 0 16px;
        font-style: normal;
        font-weight: 500;
        font-size: 10px;
        line-height: 13px;
        letter-spacing: 0.06em;
        color: ${(p) => p.theme.dropdown.textColor};
      }
    
      .brg-input__single-value {
        color: ${(p) => p.theme.dropdown.textColor};
      }

    
`;

export const RepostedText = styled.div`
  font-size: 20px;
  line-height: 28px;
  color: ${(p) => p.theme.dropdown.textColor};
  text-align: center;
`

export const RadioContainer = styled(FlexBox)`
  * {
  margin-bottom: 0px;
}
`;

export const FieldTitle = styled.div<any>`
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 133.333% */
    letter-spacing: -0.3px;
    color: ${p => p.theme.not_saved_modal.channelTitle || '#151514'};
    margin-bottom: 12px;
`;
